// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import axios from 'axios'
import Vuex from 'vuex'
import store from './store/index.js'
import './assets/Scripts/ditu.js'
import 'babel-polyfill'
import "./assets/css/cui.css";
import "./assets/css/style.css";
// import "./assets/css/less.css";
import "./assets/css/animate.css";
import "./assets/css/flexslider.css";
import{ get,post,put} from './assets/Scripts/request.js'
import './assets/Scripts/ditu.js'

//定义全局变量
Vue.prototype.$post=post;
Vue.prototype.$get=get;
Vue.prototype.$put=put;

Vue.config.productionTip = false
Vue.prototype.$axios = axios; // 在vue中使用axios

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>'
})
export default vue

// const router = new VueRouter({
//   routes: r,
//   //在此处加入
//   scrollBehavior(to,from,savedPosition){
//     if(savedPosition){
//       return savedPosition;
//     }else{
//       return {x:0,y:0}
//     }
//   },
// })


// WEBPACK FOOTER //
// ./src/main.js